import { FunctionComponent, memo, useMemo } from 'react';
import { ConfigCustomEmojis } from '../../services';
import { useCustomEmoji } from '../../shared';
import { Angry } from './Angry';
import { Haha } from './Haha';
import { Like } from './Like';
import { Love } from './Love';
import { Sad } from './Sad';
import { Wow } from './Wow';

interface EmojiProps {
  reaction: string;
  size?: number;
}

export const Emoticon: FunctionComponent<EmojiProps> = memo(({ reaction, size = 20 }) => {
  const { customEmoji } = useCustomEmoji({ emojiKey: reaction as keyof ConfigCustomEmojis, size });

  const content = useMemo(() => {
    if (customEmoji) {
      return customEmoji;
    }

    switch (reaction) {
      case 'like':
        return <Like size={size} />;
      case 'love':
        return <Love size={size} />;
      case 'haha':
        return <Haha size={size} />;
      case 'wow':
        return <Wow size={size} />;
      case 'sad':
        return <Sad size={size} />;
      case 'angry':
        return <Angry size={size} />;
      default:
        return null;
    }
  }, [customEmoji, reaction, size]);

  return content;
});
